import { SvgIcon, SvgIconProps } from '@material-ui/core'

type ShareScreenIconProps = SvgIconProps & { withGradient?: boolean }

export default function ShareScreenIcon({ withGradient = false, ...rest }: ShareScreenIconProps) {
    return (
        <SvgIcon viewBox="0 0 25 25" fill="none" {...rest}>
            <g>
                <defs>
                    <radialGradient
                        id="gradient_fill"
                        cx="0"
                        cy="0"
                        r="1"
                        gradientUnits="userSpaceOnUse"
                        gradientTransform="translate(2.2939 3.65764) rotate(48.9028) scale(29.7834 85.9525)"
                    >
                        <stop stopColor="#FCE640" />
                        <stop offset="0.770739" stopColor="#F49629" />
                        <stop offset="1" stopColor="#F17E22" />
                    </radialGradient>
                </defs>
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M15.9355 4.90234C18.2155 4.90234 19.3557 4.90205 20.2266 5.3457C20.9925 5.73599 21.6155 6.35905 22.0059 7.125C22.4496 7.99591 22.4492 9.13682 22.4492 11.417V13.5879C22.4492 15.8679 22.4495 17.008 22.0059 17.8789C21.6155 18.645 20.9926 19.2679 20.2266 19.6582C19.3557 20.1019 18.2156 20.1025 15.9355 20.1025H8.06445C5.78428 20.1025 4.64337 20.102 3.77246 19.6582C3.00655 19.2679 2.38344 18.6449 1.99316 17.8789C1.54961 17.008 1.5498 15.8677 1.5498 13.5879V11.417C1.5498 9.13682 1.54941 7.99591 1.99316 7.125C2.38348 6.35902 3.00648 5.73602 3.77246 5.3457C4.64337 4.90195 5.78428 4.90234 8.06445 4.90234H15.9355ZM11.9492 8.50195C11.8478 8.50195 11.7495 8.53252 11.667 8.58887L11.5908 8.65332L9.09082 11.2246C8.89838 11.4225 8.90276 11.7391 9.10059 11.9316C9.29857 12.1241 9.61512 12.1198 9.80762 11.9219L11.4492 10.2334V15.002C11.4492 15.2781 11.6731 15.502 11.9492 15.502C12.2254 15.502 12.4492 15.2781 12.4492 15.002V10.2334L14.0908 11.9219L14.168 11.9873C14.3602 12.1182 14.6246 12.1001 14.7979 11.9316C14.971 11.7632 14.9965 11.4995 14.8711 11.3037L14.8076 11.2246L12.3076 8.65332C12.2135 8.55655 12.0842 8.50195 11.9492 8.50195Z"
                    fill={withGradient ? 'url(#gradient_fill)' : 'currentColor'}
                />
            </g>
        </SvgIcon>
    )
}
